<script setup>
import { PerfectScrollbar } from 'vue3-perfect-scrollbar'
import Helper from "@helpers/Helper.js"
import get from "lodash.get"
import AppStaffRole from "@/views/staff/AppStaffRole.vue"
import { leaveAllEchoChannels } from "@/helpers/echoConfig"

const ability = useAbility()

const { signOut, data } = useAuth()
const userData = get(data, 'value.user')

async function logout() {
  try {
    if (import.meta.client && window?.Echo) {
      leaveAllEchoChannels(window.Echo)
    }

    await signOut({ redirect: false })

    // Reset user abilities
    ability.update([])
    navigateTo({ name: 'login' })
  } catch (error) {
    throw createError(error)
  }
}

const userProfileList = [
  {
    type: 'navItem',
    icon: 'tabler-user',
    title: 'Thông tin cá nhân',
    to: '/profile',
  },
  { type: 'divider' },
  {
    type: 'navItem',
    icon: 'tabler-logout',
    title: 'Đăng xuất',
    onClick: logout,
  },
]
</script>

<template>
  <VBadge
    v-if="userData"
    dot
    bordered
    location="bottom right"
    offset-x="3"
    offset-y="3"
    color="success"
  >
    <div class="me-2 d-f-c d-fj-c">
      <strong>{{ userData.name }}</strong>
      <span
        v-if="userData.code"
        style="padding: 0; margin: 0; height: 12px"
      >
        <VChip
          color="primary"
          variant="text"
          class="text-center"
          :rounded="false"
          style="margin: 0; padding: 0; font-size: 12px; height: 12px"
        >{{ userData.code }}</VChip>
      </span>
    </div>
    <VAvatar
      class="cursor-pointer"
      color="primary"
      variant="tonal"
    >
      <VImg
        v-if="userData && userData.avatar"
        :src="userData.avatar"
      />
      <VIcon
        v-else
        icon="tabler-user"
      />
      <VMenu
        activator="parent"
        width="230"
        location="bottom end"
        offset="14px"
      >
        <VList>
          <VListItem>
            <template #prepend>
              <VListItemAction start>
                <VBadge
                  dot
                  location="bottom right"
                  offset-x="3"
                  offset-y="3"
                  color="success"
                  bordered
                >
                  <VAvatar
                    color="primary"
                    variant="tonal"
                  >
                    <VImg
                      v-if="userData && userData.avatar"
                      :src="userData.avatar"
                    />
                    <VIcon
                      v-else
                      icon="tabler-user"
                    />
                  </VAvatar>
                </VBadge>
              </VListItemAction>
            </template>
            <VListItemTitle class="font-weight-medium">
              {{ userData.name }}
            </VListItemTitle>
            <VListItemSubtitle style="font-size: 12px; font-weight: lighter; color: gray">
              {{ userData.code }}
            </VListItemSubtitle>
            <VListItemSubtitle>
              <AppStaffRole
                :model-value="userData.role_id"
                disabled
              />
            </VListItemSubtitle>
          </VListItem>

          <PerfectScrollbar :options="{ wheelPropagation: false }">
            <template
              v-for="item in userProfileList"
              :key="item.title"
            >
              <div>
                <VListItem
                  v-if="item.type === 'navItem'"
                  :to="item.to"
                  @click="item.onClick && item.onClick()"
                >
                  <template #prepend>
                    <VIcon
                      class="me-2"
                      :icon="item.icon"
                      size="22"
                    />
                  </template>

                  <VListItemTitle>{{ item.title }}</VListItemTitle>

                  <template
                    v-if="item.badgeProps"
                    #append
                  >
                    <VBadge v-bind="item.badgeProps" />
                  </template>
                </VListItem>

                <div
                  v-else
                  class="mt-2 mb-2"
                  style="background: #eaeaea; width: 100%; height: 1px"
                />
              </div>
            </template>
          </PerfectScrollbar>
        </VList>
      </VMenu>
    </VAvatar>
  </VBadge>
</template>
